import { Input as ChakraInput, Flex, FormLabelProps, InputProps } from '@chakra-ui/react';
import * as React from 'react';
import { UndoEdit } from '../../iconButtons/UndoEdit';
import { CustomFormControl, DirectionProp } from '../CustomFormControl';
import { withConfirm } from '../withConfirm';

export interface IProps extends DirectionProp {
  id?: string;
  name?: string;
  value?: string | number;
  label?: string;
  subText?: string;
  disabled?: boolean;
  type?: string;
  autoFocus?: boolean;
  autoSuggest?: boolean;
  autoSuggestControl?: React.ReactNode;
  placeHolder?: string;
  inputHelperText?: string;
  errorText?: string;
  showErrorText?: boolean; // for components that inherent this one
  forwardedRef?: ((instance: HTMLInputElement | null) => void) | React.RefObject<HTMLInputElement> | null | undefined;
  onChange?: (event: React.FormEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FormEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FormEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  canUndo?: boolean;
  onUndo?: () => void;
  undoSize?: 'lg' | 'md' | 'sm';
  addSpacer?: boolean;
  size?: 'lg' | 'md' | 'sm';
  mb?: number | string;
  inputProps?: InputProps & { 'data-sentry-mask'?: string };
  labelProps?: FormLabelProps;
}

const Input: React.FC<IProps> = (props: IProps) => {
  const {
    id = 'one-line-input-default',
    name,
    errorText,
    canUndo = false,
    onUndo,
    undoSize,
    size = 'lg',
    mb = 0,
    direction,
    inputProps,
    inputHelperText,
    labelProps,
    ...otherProps
  } = props;

  const autoSuggest = otherProps.autoSuggest ? '-search' : '';
  const inputName = name || `${id}-input${autoSuggest}`;

  return (
    <CustomFormControl
      id={id}
      controlProps={{
        isInvalid: !!errorText,
        mb,
      }}
      direction={direction}
      size={size}
      label={otherProps.label}
      labelProps={{ htmlFor: `${id}-input-field`, ...labelProps }}
      subLabel={otherProps.subText}
      error={errorText}
      helperText={inputHelperText}
    >
      <Flex gap={{ base: 1, lg: 2 }} position={otherProps.autoSuggest ? 'relative' : undefined}>
        <ChakraInput
          id={`${id}-input-field`}
          name={inputName}
          data-selector={`${id}-input-field`}
          placeholder={otherProps.placeHolder ? otherProps.placeHolder : ''}
          onChange={otherProps.onChange}
          type={otherProps.type}
          value={otherProps.value}
          autoFocus={otherProps.autoFocus}
          ref={otherProps.forwardedRef}
          onBlur={otherProps.onBlur}
          onFocus={otherProps.onFocus}
          onKeyDown={otherProps.onKeyDown}
          autoComplete="off"
          autoCorrect="off"
          spellCheck={false}
          isDisabled={otherProps.disabled}
          size={size}
          {...inputProps}
        />

        {otherProps.autoSuggest ? otherProps.autoSuggestControl : null}

        {canUndo ? <UndoEdit id={id} onUndo={onUndo} size={undoSize} /> : null}
      </Flex>
    </CustomFormControl>
  );
};

const InputWithConfirm = withConfirm(Input);

export { Input, InputWithConfirm };
